import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid, Typography } from '@material-ui/core';

import {
  useUpdateClientFollowMappingMutation,
  ClientFollowMappingFragment,
  ClientLocationFragment,
} from 'api';
import { DepartmentPicker } from 'components/Pickers';
import { useNotify } from 'hooks';
import { useUpdateClientFollowMapping } from 'features/admin/updaters';

import { EMPTY_FOLLOW_CONDITIONS } from './constants';

interface IProps {
  mapping: ClientFollowMappingFragment;
}

const DepartmentsEdit: FC<IProps> = ({ mapping }) => {
  const notify = useNotify();
  const { t } = useTranslation();

  const ids = getFollowConditions().department_id;
  const mutationOptions = useUpdateClientFollowMapping();
  const { mutate, isLoading } = useUpdateClientFollowMappingMutation({
    onSuccess: editNotify,
    ...mutationOptions,
  });

  function getRequiredValues() {
    const { id, title, mapping_status, all_users } = mapping;
    return { id, title, mapping_status, all_users };
  }

  function getFollowConditions() {
    return mapping.follow_conditions || EMPTY_FOLLOW_CONDITIONS;
  }

  function editNotify() {
    const message = t('components:savedSuccessfully');
    notify.info({ message });
  }

  function handleChange(departmentIds: Array<ClientLocationFragment['id']>) {
    mutate({
      data: {
        ...getRequiredValues(),
        follow_conditions: {
          department_id: departmentIds,
          location_id: getFollowConditions().location_id || [],
        },
      },
    });
  }

  return (
    <Grid container>
      <Grid item xs={3}>
        <Box mt={2}>
          <Typography variant="subtitle2">{t('common:department_plural')}</Typography>
        </Box>
      </Grid>
      <Grid item xs={9}>
        <DepartmentPicker
          selectedDepartmentIds={ids}
          onDepartmentChange={handleChange}
          saving={isLoading}
        />
      </Grid>
    </Grid>
  );
};

export default DepartmentsEdit;
